// Viator bookable experiences.
//
// A cached ViatorExperience record is turned into the same shape as a Listing, so
// the existing cards, rails, filters, map pins and detail overlay read partner
// experiences without any special casing.

export const VIATOR_SOURCE = "viator";
export const VIATOR_BADGE_LABEL = "Book on Viator";
export const VIATOR_CARD_BADGE = "Viator · TripAdvisor";
export const VIATOR_RAIL_TITLE = "Found on Tripadvisor";
export const VIATOR_RAIL_SUBTITLE =
  "The tours, cruises and adventures travelers book most — reserved securely through our booking partner";

// Every Viator click has to carry the guide's own affiliate id, or the booking
// pays nobody. The partner API's links arrive with it already; this puts it back
// on any link that arrives without one — a hand-pasted URL, or a record cached
// before the id was set — so no banner on the site sends an untracked click.
export const VIATOR_AFFILIATE_ID = "P00295549";
export const VIATOR_MCID = "42383";

export function withViatorTracking(url) {
  if (!url) return url;
  const href = /^https?:\/\//i.test(url) ? url : `https://${url}`;
  let parsed;
  try {
    parsed = new URL(href);
  } catch {
    return url;
  }
  if (!/(^|\.)viator\.com$/i.test(parsed.hostname)) return url;
  if (!parsed.searchParams.get("pid")) parsed.searchParams.set("pid", VIATOR_AFFILIATE_ID);
  if (!parsed.searchParams.get("mcid")) parsed.searchParams.set("mcid", VIATOR_MCID);
  if (!parsed.searchParams.get("medium")) parsed.searchParams.set("medium", "api");
  return parsed.toString();
}

// Experiences that carry the island's music story; the Bad Bunny rail leads the page.
export const BAD_BUNNY_THEME = "bad-bunny";
// Rides as the eyebrow on ordinary experience cards, so the themed trip is
// identifiable without a billboard.
export const BAD_BUNNY_LABEL = "Bad Bunny · Puerto Rico";

const VIATOR_TITLE_ES = {
  "438706P2":"Alquiler de yate de lujo Intrepid de 47 pies por 4 horas en Fajardo",
  "308545P10":"Traslado privado de ida y vuelta al bosque de Carabalí",
  "164005P2":"Recorrido por cuevas",
  "389200P6":"Excursión de snorkel en Vieques",
  "5700591P2":"Recorrido a pie por el Viejo San Juan con fotos profesionales",
  "334155P10":"Aventura de rápel en el bosque tropical de Puerto Rico",
  "5605185P2":"Experiencia de cosecha de café en Hacienda La Tradición",
  "5669579P7":"Alquiler de scooter Vespa en San Juan: explora a tu ritmo",
  "5681225P2":"Traslado de ida desde el aeropuerto a Condado, Isla Verde o el Viejo San Juan",
  "485285P5":"Recorrido panorámico en auto por el Viejo San Juan y parada para nadar",
  "5700022P1":"El Pirata: La mentira del gobernador — búsqueda de misterio en el Viejo San Juan",
  "161836P16":"Alquiler privado de barco en La Parguera a Cayo Caracoles y bancos de arena",
  "5529094P1":"Entrada general al Parque de las Ciencias",
  "345561P1":"Paseo en barco por la bahía bioluminiscente Mosquito, Vieques",
  "104204P860":"Búsqueda del tesoro: redescubre el Viejo San Juan",
  "164005P8":"Recorrido por el tobogán natural de El Yunque y la playa de Luquillo",
  "5689751P2":"Clase de cocina puertorriqueña en Heaven Hills Kitchen",
  "214460P60":"Traslado al puerto de cruceros de San Juan",
  "5569038P11":"Traslado de ida y vuelta desde el aeropuerto SJU a Isla Verde, Condado o el Viejo San Juan",
  "379565P14":"Traslado accesible desde el aeropuerto a Dorado, Río Grande o Luquillo",
  "128285P704":"Traslado privado de ida y vuelta del aeropuerto de Aguadilla a Isabela",
  "128285P1048":"Traslado privado de ida y vuelta del aeropuerto de San Juan a Vega Baja",
  "477814P29":"Experiencia de día completo: El Yunque, playa, Viejo San Juan y kioscos",
  "350808P2602":"Recorrido privado en velero y snorkel en Fajardo",
  "203528P4":"Hablemos de política",
  "347171P5":"Aventura en yate crucero de 54 pies",
  "5551388P4":"Picnic con sesión de fotos en San Juan",
  "5605805P3":"Destilación casera de aceites esenciales",
  "128285P607":"Traslado privado de salida desde Isabela o Hatillo al aeropuerto SJU",
  "5678824P2":"Clase de coctelería y degustación de licores en Puerto Rico",
  "5638506P3":"Recorrido de chinchorreo por Piñones, Luquillo y Santurce",
  "320728P2290":"Recorrido privado de día completo desde el puerto de cruceros de Ponce",
  "320728P103":"Traslado privado del aeropuerto de Aguadilla a Hatillo",
  "350808P2603":"Excursión privada de buceo en San Juan",
  "379565P13":"Traslado accesible al aeropuerto para Isla Verde, Condado u Ocean Park",
  "5694931P2":"Excursión a la bahía bioluminiscente de Vieques en kayak transparente",
  "5613066P1":"Aventura de senderismo en el manantial de Guayaney",
  "203528P5":"Hablemos de política en Puerto Rico",
  "308545P25":"Traslado en taxi del aeropuerto de San Juan a Aguadilla",
  "5681958P1":"Transporte privado desde la terminal de ferris de Ceiba",
  "161836P15":"Recorrido en barco en grupo pequeño por la bahía bioluminiscente de La Parguera",
  "5497976P16":"Recorrido desde San Juan por la montaña PR-10 y más de diez pueblos",
  "244817P8":"Alquiler privado de barco de día completo de Fajardo a Vieques",
  "5577523P13":"Recorrido fotográfico por San Juan con fotógrafo profesional",
  "203528P10":"Leer el ambiente: cultura y contexto",
  "350808P1277":"Traslado de ida y vuelta del aeropuerto de Aguadilla a Isabela o Hatillo",
  "214460P59":"Traslados en San Juan",
  "5581806P8":"Traslado privado de lujo a Hacienda Carabalí",
  "89247P6":"Alquiler privado de barco y snorkel por 5 horas en Fajardo con tabla de quesos",
  "350808P26":"Traslado privado del aeropuerto Luis Muñoz Marín a un hotel en Río Grande",
  "5692903P1":"Recorrido de arte urbano: murales e historias escondidas",
  "5618912P5":"Autobús de fiesta y juego de béisbol en Puerto Rico",
  "5583581P10":"Recorrido a pie por el chocolate, el arte y la arquitectura del Viejo San Juan",
  "128285P714":"Traslado privado de salida de Isabela o Hatillo al aeropuerto de Aguadilla",
  "320728P285":"Traslado privado del aeropuerto de San Juan al puerto de cruceros de Ponce",
  "379782P11":"Transporte desde San Juan a los toboganes naturales de El Yunque",
  "214460P55":"Recorrido por varias playas de Puerto Rico",
  "5614527P1":"Recorrido guiado en tranvía histórico por el Viejo San Juan de una hora",
  "5691264P1":"Recorrido de bares y baile por el Viejo San Juan",
  "320728P284":"Traslado privado del puerto de cruceros de Ponce al aeropuerto SJU",
  "5686150P268":"Recorrido de audio autoguiado por el arte y la música de Santurce",
  "273865P13":"Alquiler de equipo de snorkel en la laguna del Condado",
  "393101P28":"Recorrido costero en bicicleta hasta el Viejo San Juan",
  "5572688P5":"Recorrido a Charco el Hippie",
  "128285P3849":"Traslado privado de llegada del aeropuerto SJU al puerto de San Juan",
  "5644747P1":"Recorrido de agroturismo en Manatí con guía",
  "358426P1":"Servicio de transporte",
  "308545P19":"Traslado en taxi de San Juan a Kayak Village",
  "31523P23":"Explora el oeste de Puerto Rico desde San Juan",
  "350808P2612":"Recorrido privado de día completo por el oeste de Puerto Rico",
  "350808P2611":"Recorrido privado a una cascada en Puerto Rico",
  "273865P25":"Recorrido nocturno en bicicleta con luces por San Juan y Condado",
  "5518944P2":"Cena de arte y vino en Puerto Rico con traslado de ida",
  "5514984P1":"Sesión de fotografía profesional de 45 minutos en Puerto Rico",
  "350808P2609":"Recorrido privado de coctelería artesanal y ciudad en San Juan",
  "5566175P1":"Sesión de retratos en la playa",
  "7626P871":"Clase privada de cocina puertorriqueña con la chef Viviana",
  "5569038P5":"Servicio privado de transporte de día completo (8 horas)",
  "350808P1275":"Traslado privado de llegada del aeropuerto de Aguadilla a Isabela",
  "5497976P11":"Recorrido de bienestar en Puerto Rico: yoga, inmersión en agua fría y aguas termales",
  "40380P425":"Traslado en auto del Viejo San Juan al aeropuerto SJU",
  "5607533P6":"Recorrido privado por El Yunque y brunch frente a la playa",
  "5562339P1":"Aventura de búsqueda del tesoro, caminata y hallazgo de tu propio tesoro",
  "308545P23":"Traslado privado en taxi del aeropuerto de San Juan a Rincón",
  "446634P14":"Recorrido bioluminiscente en kayak transparente por Vieques",
  "347171P8":"Paseo en barco por Puerto Rico",
  "128285P511":"Traslado privado de ida y vuelta del aeropuerto SJU a Isabela o Hatillo",
  "467173P1":"Recorrido por bares locales del distrito artístico de San Juan",
  "5657034P6":"San Juan en UTV Can-Am 2026 y una moto acuática gratis",
  "379782P6":"Traslado privado del aeropuerto SJU a hoteles de Humacao",
  "5665182P1":"Snorkel al atardecer y aventura costera en Aguadilla",
  "128285P3556":"Recorrido privado de compras desde San Juan a Puerto Rico Premium Outlets",
  "5686150P120":"Recorrido de audio autoguiado por San Juan: lo sagrado y lo destilado",
  "171122P19":"Recorrido por el parque acuático escondido de El Yunque desde San Juan",
  "89247P3":"Aventura privada nocturna de snorkel y barco en Fajardo con aperitivos",
  "40380P428":"Traslado en minibús del Viejo San Juan al aeropuerto SJU",
  "379782P12":"Recorrido por los toboganes de El Yunque y la playa de Luquillo",
  "5569038P8":"Traslado privado entre San Juan y Ponce",
  "128285P1556":"Traslado privado de salida desde hoteles de San Juan al aeropuerto SJU",
  "347171P6":"Aventura privada en catamarán de 42 pies en Puerto Rico",
  "5693322P4":"Transporte entre la terminal de ferris de Ceiba, el aeropuerto y San Juan",
  "5651975P10":"Recorrido por cascadas, toboganes naturales y playas de El Yunque",
  "5581806P6":"Transporte privado a los ferris de Ceiba",
  "473430P8":"Aventura de dos días en El Yunque con toboganes naturales y campamento",
  "438706P5":"Alquiler de yate de lujo Intrepid de 47 pies por 6 horas en Fajardo",
  "128285P1033":"Traslado privado de ida y vuelta del aeropuerto SJU a hoteles de San Juan",
  "128285P433":"Traslado privado de llegada del aeropuerto SJU a un hotel en Río Grande",
  "5497976P12":"Recorrido histórico guiado a pie por el Parque de Bombas en Ponce",
  "128285P305":"Traslado privado de llegada del aeropuerto SJU a hoteles de Ponce",
  "40637P9":"Recorrido privado de snorkel en El Kraken: Vieques por la mañana o Icacos por la tarde",
  "215128P7":"Alquiler privado de catamarán a la isla Palomino",
  "128285P3560":"Recorrido privado de compras desde hoteles de San Juan a Outlet 66 Mall",
  "128285P302":"Traslado privado de ida y vuelta del aeropuerto SJU a hoteles de Ponce",
  "5583581P9":"Recorrido accesible por el Viejo San Juan, pensado para todos",
  "438706P4":"Alquiler de megayate de lujo de 82 pies por 6 horas en Fajardo",
  "5518942P2":"Descubre toboganes de río y carreteras de montaña",
  "5651975P7":"Aventura en cuevas y cascadas junto a los acantilados de Arecibo",
  "477814P19":"Traslado exprés grupal al aeropuerto de Utopía",
  "477814P38":"Aventura de snorkel en Aguadilla",
  "5616885P4":"Recorrido en moto acuática al atardecer",
  "350808P2604":"Recorrido privado a una playa de arena negra en el sureste de Puerto Rico",
  "338297P17":"Explora Puerto Rico en scooter con un recorrido guiado a tu ritmo",
  "203528P8":"Por qué importan las creencias",
  "128285P303":"Traslado privado de salida de hoteles de Ponce al aeropuerto SJU",
  "128285P300":"Traslado privado de salida de un hotel en Río Grande al aeropuerto SJU",
  "114689P7":"Transporte terrestre del aeropuerto SJU para grupos y familias",
  "5676145P2":"Recorridos privados por las playas, la naturaleza y el Viejo San Juan",
  "203528P30":"Caminata histórica y cultural por Aibonito",
  "5549562P1":"Sesión fotográfica romántica para parejas en Ponce",
  "320728P286":"Traslado privado del puerto de cruceros de Ponce a hoteles de San Juan",
  "5679195P2":"Servicio de montaje de playa en San Juan",
  "320728P102":"Traslado privado del aeropuerto de Aguadilla a Isabela",
  "334155P6":"Experiencia en el bosque nacional El Yunque",
  "5551388P5":"Propuesta de matrimonio con montaje romántico en San Juan",
  "5686150P77":"Recorrido de audio autoguiado: la revuelta y el alma de San Juan",
  "454300P3":"Aventura de senderismo por cuevas escondidas, cascadas y playa",
  "5613066P7":"Caminata a Charco Prieto para aventureros con experiencia",
  "350808P2600":"Recorrido privado por el cañón, el río y las cascadas de Utuado",
  "128285P2623":"Traslado privado de salida de Vega Baja al aeropuerto SJU",
  "335786P4":"Traslado entre San Juan y Rincón",
  "320477P6":"Sesión fotográfica con vestido volador encantado",
  "214460P41":"Recorrido por la costa norte",
  "5497976P8":"San Juan: los orígenes de Bad Bunny y recorrido gastronómico cultural",
  "110804P1134":"Historia del reguetón en San Juan: recorrido de audio autoguiado",
  "42080P2":"Aventura por el bosque tropical y el río de El Yunque",
  "322734P15":"Caminata en grupo pequeño por Cerro Mime y salto de acantilado",
  "404871P8":"Aventura a la cascada escondida de Charco Prieto desde San Juan",
  "5615538P3":"Clase de pole dance y picnic junto al mar en San Juan",
  "110420P3":"Paseo privado a vela por la costa sur: historia y educación",
  "5497976P9":"Recorrido por tiendas de humo, cigarros y ambiente isleño en San Juan",
  "40637P5":"Excursión en barco con snorkel y tobogán acuático en Icacos o Vieques, todo incluido",
  "101727P4":"Recorrido en grupo pequeño por El Yunque y sus toboganes naturales, muy bien valorado",
  "64529P1":"Aventura en ATV para una persona cerca de San Juan",
  "36441P1":"Clase de coctelería en Casa BACARDÍ, Puerto Rico",
  "45107P2":"Recorrido guiado de snorkel con tortugas en San Juan y videos de cortesía",
  "71908P2":"Excursión en barco con playa y snorkel a la isla Icacos, todo incluido",
  "481338P4":"Tres recorridos en un día: Viejo San Juan, bosque tropical y playa con transporte",
  "64529P7":"Recorrido en UTV todoterreno: explora Puerto Rico a minutos de San Juan",
  "455136P1":"Cena FlyDining de cuatro platos en el Viejo San Juan: atardecer o luces de la ciudad",
  "322734P2":"Aventura por cuevas, cascadas y río en Charco Azul desde San Juan",
  "4170DIFF":"Crucero en catamarán a la isla desierta de Icacos, con snorkel y picnic",
  "214579P1":"Puerto Rico: alquiler de motos acuáticas nuevas en la playa de Isla Verde",
  "333045P1":"Recorrido por El Yunque, toboganes naturales, cascada, comida y fotos",
  "195978P10":"Desde San Juan: toboganes de El Yunque y playa de Luquillo",
  "29733P8":"Excursión de snorkel y playa en Culebra, todo incluido",
  "29733P2":"Sea Trek submarino en San Juan: explora bajo las olas",
  "9266P2":"Snorkel con tortugas y aventura en Flamenco Beach, Culebra, con ferry",
  "31820P4":"La tirolesa The Beast en el parque de aventuras ToroVerde, Puerto Rico",
  "484319P2":"Recorrido por la bahía bioluminiscente de Vieques en canoas transparentes",
  "395618P1":"Recorrido en moto acuática por la bahía de San Juan (edad mínima para alquilar: 21 años)",
  "47300P1":"Tirolesa en las estribaciones del bosque nacional",
  "6013FAJ":"Excursión de snorkel en catamarán a Culebra desde Fajardo",
  "107272P1":"Kayak nocturno por las luces de la ciudad en la laguna del Condado",
  "244937P4":"Recorrido todo incluido en catamarán de lujo a la isla Icacos",
  "171122P18":"Excursión desde San Juan en ferry a la bahía bioluminiscente y la playa de Vieques",
  "9266P3":"Recorrido en kayak por la bahía bioluminiscente de Fajardo",
  "350273P2":"Toboganes naturales, cascadas y columpio de cuerda en El Yunque",
  "101727P7":"Recorrido guiado de medio día por El Yunque con tobogán natural y columpio de cuerda",
  "481338P1":"Dos recorridos en un día: aventura de bosque tropical y playa con transporte",
  "5519936P1":"Alquiler de McLaren azul con San Juan PR Watersports",
  "448604P1":"Explora el Viejo San Juan en carrito de golf (desde 2023)",
  "44586P1":"Paseo a caballo por la playa de Luquillo desde el parque de aventuras Carabalí",
  "24791P7":"Excursión de snorkel de día completo a Culebra con almuerzo",
  "6013WIND":"Paseo diurno en catamarán a la isla Icacos desde Fajardo",
  "41096P7":"Snorkel y día de playa en Culebra con almuerzo y bebidas",
  "376702P1":"Conduce un UTV Can-Am por la playa en San Juan, Puerto Rico",
  "486634P7":"San Juan: snorkel con tortugas y videos de cortesía",
  "5540830P1":"Recorrido en kayak por la bahía bioluminiscente de la isla Vieques",
  "107272P6":"Recorrido en kayak transparente por la laguna del Condado",
  "57869P10":"Aventura de tubing por cuevas del bosque tropical y caminata a cascadas",
  "6013P15":"Día completo de playa y diversión en Culebra en catamarán",
  "275911P1":"Recorrido en grupo pequeño por cascadas y toboganes naturales de El Yunque, con recogido",
  "171122P21":"Boletos de ferry a Culebra y transporte de ida y vuelta desde San Juan",
  "104842P2":"Paseo diurno en velero con transporte desde San Juan, Condado e Isla Verde",
  "64529P4":"Aventura en ATV para dos personas cerca de San Juan",
  "5519936P2":"Alquiler de McLaren verde con San Juan PR Watersports",
  "195978P2":"Paseo en barco por la bahía bioluminiscente de La Parguera y baño, con transporte desde San Juan",
  "332386P1":"Tres aventuras en un día: Cueva Ventana, Cueva del Indio y cascada",
  "16627P3":"Parque de tirolesas JungleQui en el bosque nacional El Yunque",
  "5229P2":"Paseo en barco al atardecer por el puerto de San Juan",
  "24791P4":"Recorrido en kayak por la bahía bioluminiscente de Fajardo",
  "378933P1":"Recorrido de medio día en grupo pequeño por El Yunque con transporte y tobogán natural",
  "329404P4":"Experiencia privada todo incluido de navegación y snorkel por los cayos de la costa este",
  "334155P1":"Recorrido por El Yunque con parada para almorzar en Luquillo y transporte (máximo 6 personas)",
  "5597398P1":"Catamarán a la isla desierta de Icacos, con snorkel, navegación y playa",
  "320305P1":"Ruta de bares del Viejo San Juan: descubre los lugares favoritos de la gente local",
  "5584DINNER":"Recorrido gastronómico por los sabores auténticos de San Juan",
  "64529P6":"Paseo a caballo en un rancho privado",
  "5518942P1":"El recorrido perfecto por Puerto Rico",
  "36441P3":"Recorrido Legacy en Casa BACARDÍ, Puerto Rico",
  "14939P2":"Fajardo: excursión de snorkel en catamarán a la isla Icacos con almuerzo",
  "42873P6":"Tirolesa en El Yunque, Puerto Rico",
  "320477P3":"Sesión de fotos privada en una playa escondida de Puerto Rico",
  "139082P3":"Recorrido sin filas por la destilería Ron del Barrilito y experiencia de coctelería",
  "9266P1":"Recorrido autoguiado en minibote con snorkel a la isla Icacos",
  "31820P6":"Recorrido de aventura en tirolesa",
  "358368P1":"Recorrido en grupo pequeño por los toboganes naturales de El Yunque, con transporte y fotos",
  "203015P1":"Aventura en kayak por una bahía bioluminiscente de Puerto Rico",
  "174461P1":"Snorkel con tortugas y videos en San Juan",
  "329404P5":"Crucero privado al atardecer y de noche por la bahía de San Juan",
  "310626P2":"Clase de salsa al atardecer en la playa de San Juan",
  "162160P3":"Excursión de dos experiencias en un día: El Yunque y la bahía bioluminiscente, con transporte",
  "244937P2":"Snorkel de medio día en catamarán de alta velocidad a la isla Icacos, con barra libre",
  "11949P2":"Paseo al atardecer en catamarán por la bahía de San Juan, con bebidas incluidas",
  "5519936P4":"Alquiler de Bugatti rojo con San Juan Watersports",
  "29733P6":"Excursión en barco con snorkel y día de playa a las islas de Fajardo, todo incluido",
  "45107P1":"Buceo para principiantes con tortugas y videos gratis en San Juan",
  "225672P1":"Excursión en kayak a la bahía bioluminiscente desde Vieques",
  "7812P280":"Recorrido gastronómico por el Viejo San Juan con siete degustaciones de sabores locales",
  "14939P3":"Recorrido de medio día a Icacos con Tobias",
  "11949P1":"Paseo diurno en velero por la bahía de San Juan, con bebidas incluidas",
  "53843P1":"Aventura de día completo con tirolesa y rápel en cascada cerca de San Juan",
  "170591P2":"Recorrido a pie para explorar el Viejo San Juan",
  "16292P1":"Recorrido a pie por el Viejo San Juan",
  "42080P1":"Paquete de día de playa en Icacos con transporte en taxi acuático desde Fajardo",
  "5513800P1":"Tirolesa en el bosque tropical de Puerto Rico",
  "5629350P2":"Recorrido en kayak transparente por una bahía bioluminiscente",
  "114689P2":"Kayak nocturno en la bahía bioluminiscente de Laguna Grande, Fajardo (7:30 p. m.)",
  "135077P1":"Paseo a caballo por playas apartadas y bosques tropicales",
  "379352P1":"Aventura inmersiva en El Yunque con transporte",
  "174461P2":"Aventura de snorkel para observar tortugas en San Juan, con videos",
  "195978P14":"Recorrido histórico a pie, compras y comida en el Viejo San Juan, con transporte",
  "389200P2":"Recorrido en kayak de fondo transparente por la bahía bioluminiscente Mosquito de Dindin",
  "486829P2":"Taller guiado para crear tu propio perfume en el Viejo San Juan",
  "399113P1":"Recorrido nocturno en kayak por la bahía bioluminiscente de Vieques",
  "129723P3":"Recorrido guiado de día completo por El Yunque desde San Juan",
  "114689P6":"Excursión de día completo: El Yunque, playa de Luquillo y kayak nocturno por la bahía bioluminiscente",
  "449481P1":"Explora El Yunque: senderismo, columpios y tobogán natural en grupo pequeño",
  "480531P1":"Experiencia de comida caribeña",
  "25948P5":"Tubing por cuevas del río Tanamá"
};

const TITLE_PHRASES_ES = [
  [/\bOld San Juan\b/gi, "Viejo San Juan"],
  [/\bRound[- ]Trip\b/gi, "de ida y vuelta"],
  [/\bOne Way\b/gi, "de ida"],
  [/\bPrivate Transfer\b/gi, "Traslado privado"],
  [/\bAirport Transfer\b/gi, "Traslado al aeropuerto"],
  [/\bTransfer\b/gi, "Traslado"],
  [/\bWalking Tour\b/gi, "Recorrido a pie"],
  [/\bGuided Walking Tour\b/gi, "Recorrido guiado a pie"],
  [/\bCooking Class\b/gi, "Clase de cocina"],
  [/\bSnorkeling\b/gi, "Snorkel"],
  [/\bScuba Diving\b/gi, "Buceo"],
  [/\bRainforest\b/gi, "bosque tropical"],
  [/\bWaterfalls?\b/gi, "cascadas"],
  [/\bWaterslides?\b/gi, "toboganes naturales"],
  [/\bBeach Hopping\b/gi, "recorrido por playas"],
  [/\bBoat Tour\b/gi, "paseo en barco"],
  [/\bBoat Charter\b/gi, "alquiler de barco"],
  [/\bPrivate Boat\b/gi, "barco privado"],
  [/\bBoat\b/gi, "barco"],
  [/\bYacht Rental\b/gi, "alquiler de yate"],
  [/\bYacht\b/gi, "yate"],
  [/\bScooter Rental\b/gi, "alquiler de scooter"],
  [/\bRental\b/gi, "alquiler"],
  [/\bScavenger Hunt\b/gi, "búsqueda del tesoro"],
  [/\bPhoto Session\b/gi, "sesión de fotos"],
  [/\bPhotographer\b/gi, "fotógrafo"],
  [/\bSunset\b/gi, "atardecer"],
  [/\bAdventure\b/gi, "aventura"],
  [/\bTour\b/gi, "recorrido"],
  [/\bExperience\b/gi, "experiencia"],
  [/\bBeach\b/gi, "playa"],
  [/\bAirport\b/gi, "aeropuerto"],
  [/\bPrivate\b/gi, "privado"],
  [/\bFull-Day\b/gi, "de día completo"],
  [/\bFull Day\b/gi, "de día completo"],
  [/\bRoundtrip\b/gi, "de ida y vuelta"],
  [/\bPuerto Rico\b/gi, "Puerto Rico"],
  [/\bSan Juan\b/gi, "San Juan"],
  [/\bFajardo\b/gi, "Fajardo"],
  [/\bEl Yunque\b/gi, "El Yunque"],
];

export function viatorTitleLabel(record, lang = "en") {
  if (lang !== "es") return record?.title || record?.name || "";
  if (record?.title_es) return record.title_es;
  const exact = VIATOR_TITLE_ES[record?.product_code];
  if (exact) return exact;
  let title = String(record?.title || record?.name || "");
  TITLE_PHRASES_ES.forEach(([pattern, replacement]) => { title = title.replace(pattern, replacement); });
  return title || "Experiencia en Puerto Rico";
}

export function viatorDurationLabel(value, lang = "en") {
  if (!value || lang !== "es") return value || "";
  return String(value)
    .replace(/\bhours?\b/gi, "horas")
    .replace(/\bminutes?\b/gi, "minutos")
    .replace(/\bdays?\b/gi, "días")
    .replace(/\bhalf[- ]day\b/gi, "medio día")
    .replace(/\bfull[- ]day\b/gi, "día completo");
}

export const priceFromLabel = (value, lang = "en") =>
  value == null || value === "" ? "" : `${lang === "es" ? "Desde" : "From"} $${Math.round(Number(value)).toLocaleString(lang === "es" ? "es-PR" : "en-US")}`;

export const ratingLabel = (value) => (value == null || value === "" ? "" : Number(value).toFixed(1));

/** A cached Viator product, shaped like a Listing. */
export function normalizeViator(record) {
  const images = (record.images || []).filter(Boolean);
  return {
    id: record.id,
    source: VIATOR_SOURCE,
    name: record.title,
    title_es: record.title_es || "",
    slug: record.product_code,
    product_code: record.product_code,
    type: "Experience",
    category: record.category || "Experiences",
    subcategory: record.subcategory || "",
    description: record.description || "",
    description_es: record.description_es || "",
    editorial_description: record.short_description || "",
    editorial_description_es: record.short_description_es || "",
    neighborhood_id: record.neighborhood_id || "",
    theme: record.theme || "",
    destination: record.destination || "",
    address: record.destination || "",
    latitude: record.latitude,
    longitude: record.longitude,
    cover_image: images[0] || "",
    gallery_images: images,
    price_label: priceFromLabel(record.price_from),
    price_from: record.price_from,
    rating: record.rating,
    review_count: record.review_count,
    duration_text: record.duration_text,
    included: record.included || [],
    included_es: record.included_es || [],
    meeting_point: record.meeting_point,
    meeting_point_es: record.meeting_point_es || "",
    cancellation_text: record.cancellation_text,
    cancellation_text_es: record.cancellation_text_es || "",
    booking_url: withViatorTracking(record.booking_url),
    featured: !!record.featured,
  };
}

// Airport transfers, private drivers and shuttles arrive in the same partner
// catalog as the tours, but they are not a trip — they are the ride that gets
// you there, so the guide reads them as a transportation service instead.
// A ride names itself first: "Airport Transfer…", "Private Transfer…",
// "Puerto Rico Island Wide Transfers…". A tour that merely includes transport
// says so later in the sentence, so leading with the ride is what separates the
// two — a regex on the whole title would swallow every "…Tour with Transport".
const RIDE_LEAD =
  /^\s*(?:(?:private|shared|luxury|premium|group|express|semi[- ]private|one[- ]way|round[- ]trip|roundtrip|island[- ]wide|sju|puerto rico island wide|puerto rico|airport)\s*){0,4}(?:transfers?|transport|transportation|shuttles?|taxi|chauffeur|private driver|car service|limousine|minibus|pickup)/i;

export const isRideService = (item) => RIDE_LEAD.test(item?.title || item?.name || "");

/** A partner transfer, shaped as a local transportation service. */
export const asRideService = (item) => ({
  ...item,
  type: "Service",
  category: "Services",
  subcategory: "Car Rentals & Transportation",
  ride_service: true,
});

/**
 * Local places and partner experiences share one results list. This spreads the
 * partner entries through the locals instead of letting them trail at the end —
 * both groups keep their own order.
 */
export function mixSources(items) {
  const locals = items.filter((i) => i.source !== VIATOR_SOURCE);
  const partner = items.filter((i) => i.source === VIATOR_SOURCE);
  if (!locals.length || !partner.length) return items;

  const every = Math.max(2, Math.round(locals.length / partner.length));
  const out = [];
  let next = 0;
  locals.forEach((item, i) => {
    out.push(item);
    if ((i + 1) % every === 0 && next < partner.length) out.push(partner[next++]);
  });
  while (next < partner.length) out.push(partner[next++]);
  return out;
}

/**
 * Partner ranking: reach first, then quality and value. A tour with thousands of
 * reviews outranks a brand-new listing with two, and between two equally popular
 * experiences the better value leads — so the rails are not a wall of $300 trips.
 */
export const partnerScore = (item) => {
  const reviews = Number(item.review_count) || 0;
  const rating = Number(item.rating) || 0;
  const price = Number(item.price_from) || 0;
  const reach = Math.log10(reviews + 1) * 6;
  const quality = rating ? (rating - 3.5) * 2 : 0;
  const value = price ? Math.max(-1.5, 2 - price / 120) : 0.5;
  return reach + quality + value;
};

/** Hand-featured experiences lead, then popularity and value. */
export const rankPartner = (items) =>
  [...items].sort(
    (a, b) => Number(!!b.featured) - Number(!!a.featured) || partnerScore(b) - partnerScore(a)
  );